import React from 'react';
import DateRangePickerWithCalendar from '../../calendar/DateRangePickerWithCalendar';

import './QuickSearchBar.css';

const InputText = React.memo(props=>{
  return(
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
      placeholder={props.placeholder}
      onKeyPress={props.onKeyPress}
    />
  )
})

const QuickSearchBar = (props) => {
  return (
    <div id="report_search">
      <div className="searchBox">
        {/* <input
          name="textfield"
          id="textfield"
          type="text"
          className="search"
          value={props.inputValue}
          onChange={props.inputOnChange}
          onKeyPress={props.inputOnKeyPress}
          placeholder="간편 검색할 키워드를 입력해주세요" /> */}
        <InputText 
          name="textfield"
          id="textfield"
          type="text"
          className="search"
          value={props.inputValue}
          onChange={props.inputOnChange}
          onKeyPress={props.inputOnKeyPress}
          placeholder="간편 검색할 키워드를 입력해주세요"
        />
        &nbsp;
        <div className="searchDate">
          {props.currentUser=='' ?
            <DateRangePickerWithCalendar authed={false} isOpen={false} minDate={props.minDate} onChange={props.calendarOnChange} value={props.calendarValue} />
            :<DateRangePickerWithCalendar authed={true} isOpen={false} minDate={props.minDate} onChange={props.calendarOnChange} value={props.calendarValue} />
          }
        </div>
        &nbsp;
        <a className="button purple_line" onClick={props.btnOnClick}>검색</a>
      </div>
    </div>
  )
}

export default QuickSearchBar;
